import { useState, useEffect } from 'react';

export default function useImageErrors(pictures: string[] | null | undefined) {
  const [imageErrors, setImageErrors] = useState<boolean[]>([]);

  useEffect(() => {
    if (!pictures) {
      setImageErrors([]);
      return;
    }
    setImageErrors(Array(pictures.length).fill(false));
  }, [pictures]);

  const handleImageError = (index: number) => {
    setImageErrors((prevErrors) => {
      const newErrors = [...prevErrors];
      newErrors[index] = true;
      return newErrors;
    });
  };

  return {
    imageErrors,
    handleImageError
  };
}
